export function isPlaceholderMedia(value) {
  if (typeof value !== 'string') return false;
  let decoded = value;
  try { decoded = decodeURIComponent(value); } catch (_) { /* Keep malformed URLs as-is. */ }
  return /picsum\.photos|source\.unsplash\.com|placehold\.co|via\.placeholder\.com/i.test(decoded);
}
